module.exports = __webpack_public_path__ + "media/images/hitfun/welcome.socials.vkontakte-05b6bd7c288cb14a6a940f68932edd99.png";